function init_joytycoon(from_php) {
  
    if (typeof from_php.configs == "undefined"){
      return false;
    }
    var main = $(".place.joytycoon");
    var joyTycoon;
    
    var loaderObj= new JoyTycoonLoader(from_php);
    loaderObj.init();
    joyTycoon = new JoyTycoonMain($("#joyTycoonMain"),copyObj(from_php.configs),copyObj(from_php.user_state));
    
    var semaphoreAjax= new mySemaphore();
    var semaphorePlay= new mySemaphore();
    semaphorePlay.use();

    if(_ON_DEV){
        console.log(from_php);
    }
    
    
    
    
    
     
    
    
    var girl_id=intval(from_php.girl_id);
    
    var timeIndexArr={
        "ajax":_moduleTimeHandler.getNewIndex(),
        "wrong":_moduleTimeHandler.getNewIndex(),
        "timeout":_moduleTimeHandler.getNewIndex(),
        "timeout_error":_moduleTimeHandler.getNewIndex(),
        "loader":_moduleTimeHandler.getNewIndex()
    };
    
    var girl_name=$.takeGirlImage(girl_id);
    
    var gameCover=main.find("#gameCover");
    var gameCoverState=main.find(".stateJS"),gameCoverWin;
    var state_cur="";
    var game_state="";
    var game_start=0;
    var secureStr=from_php.secure;
    
    var game;
    
    
    
    main.find(".bookGame").one("open",function(){
        var radius=0,dir_rot=2,dir=1,step=0,obj=main.find(".formSubmit.butLoader.soccer"),
        circleObj=obj.find(".img"),textObj=obj.find(".in"),step_mig=20;
        _moduleTimeHandler.set(timeIndexArr.loader,function(){
            radius=(radius+dir_rot)%360;
            step+=dir;
            circleObj.cssrotate(radius);
            if(step%step_mig<step_mig/2){
                textObj.addClass("hide");
            }
            else{
                textObj.removeClass("hide");
            }
        },50);
    });
    main.find(".bookGameIns").on("close",function(){
        main.find(".bookGame").bookUse("show");
        return false;
    });
    
    function postAjax(to_send,refuse_response,on_end){
        if(semaphoreAjax.use()){
            var data_send={girl_id:girl_id,page:"joytycoon"};
            data_send=$.extend(data_send,to_send);
            
            function onError(data_send){
                if(typeof data_send.game_conf=="undefined"){
                    return false;
                }
                _eventLogout.add(data_send);
            }
            
            $.mypost('/ajax',data_send, function(res) {
                var data=handleAjaxRes(res),was_clear=0;
                if(typeof data!="undefined" && data){
                    if(intval(data.level)>intval(from_php.level)){
                        _mySound.playSound("girl_smile");
                    }
                    if(intval(data.was_ended)>intval(from_php.was_ended)){
                        _mySound.playSound("girl_moan");
                        //{$qconf.action_anim}/{$qevent_id}/{$g_id}/
                        
                        $.goToLocation("joytycoonanim/"+girl_id+"/");
                        return false;
                    }
                    from_php=$.extend(from_php,data);
                    function isEnd(){
                        if(!refuse_response){
                            updateState();
                        }
                        if(typeof on_end=="function"){
                            on_end();
                        }
                    }
                    if(data_send.wait){
                        _moduleTimeHandler.setOne(timeIndexArr.ajax,function(){
                            isEnd();
                        },1500);
                    }
                    else{
                        isEnd();
                    }
                    
                }
                else{
                    onError(data_send);
                }
                semaphoreAjax.clear();
            },"json");
        }
    }
    
    
    
    
    function updateState(){
        
        if(from_php.was_error){
            showState("wrong");
        }
        else if(from_php.time_game){
            showState("game");
        }
        else{
            if(from_php.was_paid==0){
                if(from_php.try_count>0){
                    showState("init");
                }
                else{
                    showState("need_try");
                }
            }
            else if(from_php.was_shown==0){
                showState("next");
            }
            else{
                showState("game_init");
            }
        }
        main.attr("data-level",(intval(from_php.level_show)+1))
    }
    
    
    function init(){
        // main.find(".butNextLevelStartJS").click(function(){
        //     _mySound.playSound("button_click");
        //     postAjax({prepare_init:1});
        // 
        // 
        // });
        main.find(".buyGirlDateJS").click(function(){
            _mySound.playSound("button_click");
            var th=$(this),premium_count=intval(th.attr("data-need"));
            $.payByPremium(premium_count,function(){
                postAjax({buy_date:1});
            });
        });
        main.find(".showTutorialJS").click(function(){
           var tutorial_arr=[
               {type:"toy","id":2,add_ids:[]},
               {type:"ice","id":1,add_ids:[]},
               {type:"ice","id":1,add_ids:[1]},
               {type:"ice","id":2,add_ids:[]},
               {type:"ice","id":2,add_ids:[2]},
               {type:"ice","id":2,add_ids:[3]},
               {type:"ice","id":2,add_ids:[2,3]},
               
           ];
           joyTycoon.prepareTutorialMode(tutorial_arr);
           startGame({tutorial:1});
        });
        
        
//        main.find(".repeatMoveTriggerJS").click(function(){
//            _mySound.playSound("button_click");
//           var th=$(this),premium_count=intval(th.attr("data-need"));
//           $.payByPremium(premium_count,function(){
//                postAjax({buy_repeat:1});
//            });
//        });
//        main.find(".buyLiveTriggerJS").click(function(){
//            _mySound.playSound("button_click");
//           var th=$(this),premium_count=intval(th.attr("data-need"));
//           $.payByPremium(premium_count,function(){
//                postAjax({buy_live:1});
//            });
//        });
        
        updateState();
    }
    
    
    var stateFun={
        "wrong":function(win){
            var book=main.find(".popup.wrong");
            var size="big";
            var win_obj={"repeat":1,"continue":1};
            if(from_php.level<2){
                win_obj.repeat=0;
                win_obj.continue=0;
            }
            book.find("#failReasonJS").html(from_php.langs["fail"+from_php.was_error]);
            if(from_php.user_state.points<from_php.configs.general.points_need/2){
                win_obj.continue=0;
            }
            if(win_obj.repeat==0){
                main.find(".repeatMoveJS").addClass('hide');
            }
            else{
                main.find(".repeatMoveJS").removeClass('hide');
            }
            if(win_obj.continue==0){
                main.find(".nextMoveContJS").addClass('hide');
            }
            else{
                main.find(".nextMoveContJS").removeClass('hide');
                
                var qconf=from_php.configs.general;
                var part=1-from_php.user_state.points/qconf.points_need;
                var sec=Math.ceil(qconf.howlong*part);
                sec-=from_php.user_state.howlong_remain;
                sec=Math.max(qconf.repeatHowlongMin);
                
                book.find(".putJSsec").html(sec);
                
                book.find("#countCardJS").html(from_php.cards_err);
            }
            
//             win_obj={"repeat":0,"continue":0};
             
             main.find(".putGameJs[data-type='level']").html(intval(from_php.level_show)+1);
             
            if(win_obj.repeat==0 && win_obj.continue==0){
                size="mini";
            }
            book.attr("data-size",size);
            
        },
        "init":function(){
            
        },
        "need_try":function(){
            
        },
        "next":function(win){
            main.find(".putGameJs[data-type='level']").html(intval(from_php.level_show)+1);
            
            
        },
        "game_init":function(win){
            
            gameCover.addClass("hide");
            var book=main.find("#bookGameJS");
            book.bookUse("show");
            main.find(".putGameJs[data-type='level']").html(intval(from_php.level_show)+1);
        },
        "game":function(){
            gameCover.addClass("hide");
            main.find(".hideOnGameJS").addClass("hide");
            main.find(".showOnGameJS").removeClass("hide");
        }
    };
    
    
    function showState(state){
        
        main.find(".putGameJs[data-type='try']").html(from_php.try_count);
        main.find(".arrSetCountJS").attr("data-count",from_php.try_count);
        _timerManager.addTimer(".place.joytycoon .timerKeyWaitJS",from_php.try_time,1);
        _moduleTimeHandler.clear(timeIndexArr.timeout);
        
        if(state!="game"){
            main.find(".hideOnGameJS").removeClass("hide");
            main.find(".showOnGameJS").addClass("hide");
            gameCover.removeClass("hide");
        }
        
        
        state_cur=state;
        
        gameCoverWin=gameCoverState.addClass("hide").filter("[data-state='"+state+"']").removeClass("hide");
        gameCoverWin.find(".textfill").textfill();
        if(typeof stateFun[state]=="undefined"){
            alert(state+"!");
        }
        stateFun[state](gameCoverWin);
    }
    function startGame(opt){
        opt=$.extend(true,{
            tutorial:0
        },opt);
        if(!opt.tutorial){
            postAjax({start_game:1});
        }
        

        gameCover.addClass("hide");
        var book=main.find("#bookGameJS");
        book.bookUse("hide");
        main.find(".bookGameIns.book").off("close").bookUse("hide");

        main.find(".hideOnGameJS").addClass("hide");
        game_start=getCurrentTime();
        game_state="game";
        joyTycoon.startGame(main.find("#touchDivJS"));
    }
    
    
    
    
    
    init();
    
    
    
    function wasLoaded(){
        main.find(".gameIsLoadingJS").addClass("hide");
        main.find(".gameIsLoadedJS").removeClass("hide");
        main.find(".gameIsLoadedJS").find(".textfill").textfill();
        main.find(".gameStartJS").one("click",function(){
            semaphorePlay.useFun(function(){
                startGame({});
            });
            
        });
        _moduleTimeHandler.clear(timeIndexArr.loader);
    }
    
    
    
    
    
    
    
    
    
    
    
    
    var gameFun = {
        blockGame:function(){},
        endTutorial:function(){
            $.goToLocation("joytycoon/"+from_php.girl_id+"/")
        },
        endGame:function(res){
            var send={};
            if(res.type=="win"){
                send.game_conf=Base64.encode(secureStr);
            }
            else{
                send.was_error=res.reason_id;
                send.heart=res.heart;
                send.points=res.points;
                send.howlong_remain=res.howlong_remain;
                send.sec=Base64.encode(secureStr);
            }
            
            postAjax(send);
        },
    };
    
    
    loaderObj.load(function(r){
        joyTycoon.init(r,gameFun);
        wasLoaded();
        semaphorePlay.clear();
//        startGame();
    });
    
    

    $.handleBottomMenu();
}
